const JOB_TYPES = [
  { icon: 'ri-hospital-line', title: '병원간병', desc: '입원 환자 곁에서 병원 내 간병을 제공하는 일자리' },
  { icon: 'ri-home-heart-line', title: '재택간병', desc: '자택에서 어르신을 돌보는 방문형 간병 일자리' },
  { icon: 'ri-timer-line', title: '단기간병', desc: '수술·퇴원 직후 등 필요한 기간만 맡는 일자리' },
  { icon: 'ri-calendar-check-line', title: '장기간병', desc: '꾸준히 안정적으로 근무할 수 있는 장기 일자리' },
  { icon: 'ri-time-line', title: '24시간 간병', desc: '환자 곁에 상주하며 돌보는 24시간 상주 일자리' },
];

export default function JobTypesSection() {
  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>
            제공되는 간병 일자리
          </p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            내 조건에 딱 맞는 일자리를 <span style={{ color: '#2E7D6B' }}>선택</span>하세요
          </h2>
          <p className="text-sm text-gray-500 max-w-2xl mx-auto">
            코리아케어러스는 간병인에게 일자리를 <strong className="text-gray-700">먼저 제안</strong>합니다.
            지역·시간·환자 상태까지 미리 등록해 두시면, 조건이 맞는 일자리가 생길 때마다 안내해 드려요.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {JOB_TYPES.map((job) => (
            <div
              key={job.title}
              className="rounded-2xl border border-gray-100 p-6 flex flex-col items-center text-center transition-all hover:-translate-y-1 cursor-pointer"
              style={{ backgroundColor: '#fafffe' }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl mb-4"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)' }}
              >
                <i className={`${job.icon} text-2xl`} style={{ color: '#2E7D6B' }}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{job.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{job.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl" style={{ backgroundColor: '#f0f9f6' }}>
            <i className="ri-money-cny-circle-line text-xl" style={{ color: '#2E7D6B' }}></i>
            <div className="text-left">
              <p className="text-sm font-bold text-gray-900">등록비 무료</p>
              <p className="text-xs text-gray-500">사전 등록에 드는 비용은 없습니다</p>
            </div>
          </div>
          <div className="flex items-center gap-3 px-5 py-3 rounded-xl" style={{ backgroundColor: '#f0f9f6' }}>
            <i className="ri-list-check-3 text-xl" style={{ color: '#2E7D6B' }}></i>
            <div className="text-left">
              <p className="text-sm font-bold text-gray-900">원하는 일자리 선택</p>
              <p className="text-xs text-gray-500">조건이 맞는 일자리만 안내해 드려요</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}